import { Box, Button, Divider, Grid, TableCell, TableContainer, TableRow, TextField, Tooltip, Typography } from '@mui/material'
import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { useParams } from 'react-router'
import Swal from 'sweetalert2'
import api from '../../../../components/services/api'

export default function PlanZone() {
    const { id } = useParams()
    const [zoneName, setZoneName] = useState(null)
    const [row, setRow] = useState(null)
    const [tier, setTier] = useState(null)
    const [table, setTable] = useState(null)
    const [dataC, setDataC] = useState([])
    const [data, setData] = useState([])
    const [rows, setRows] = useState([]);
    function addRow() {
        const newRow = {
            id: rows?.slice(-1)[0]?.id ? rows?.slice(-1)[0]?.id + 1 : 1,
            ZoneName: '',
            Bay: null,
            Row: null,
            Tier: null,
        };

        setRows([...rows, newRow]);
    }
    const deletehand = (i) => {

        const data = rows?.filter((e) => i !== e?.id);
        setRows(data);
    };

    function findBay(max, n) {
        if (max % 2 == 0) {
            if (n >= max / 2) {
                return (n - (max / 2)) * 2 + 1
            } else {
                return max - (n * 2)
            }
        } else {
            if (n >= (max - 1) / 2) {
                return (n - ((max - 1) / 2)) * 2 + 1
            } else {
                return (max - 1) - (n * 2)
            }
        }
    }

    const handleSave = (e) => {
        e.preventDefault()
        const body = {
            VoyNo: id,
            PlanZoneList: rows
        }
        const postData = async () => {
            const res = await api.post(`api/containermovement/inbound/update/planzone`, body)
            const data = await res.data
            if (res.meta.status === true) {
                Swal.fire({
                    title: `${res.meta.message}`,
                    icon: 'success',
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: 'OK'
                }).then((result) => {
                    if (result.isConfirmed) {
                        gentable(data.PlanZoneList, dataC)
                    }
                })
            }
        }
        postData()
    }
    const getdata = async () => {

        const data = await api.get(`api/containermovement/inbound/detail/${id}`);
        const res = data?.data;
        if (data.meta.status === true) {
            setDataC(res?.Container);
            gentable(res?.Zone, res?.Container)
            setRows(res?.Zone)
        }

    };
    useEffect(() => {
        getdata();
    }, []);

    const gentable = (dataRow, dataC) => {
        let box = []
        let tbl = []
        let rows = [];
        let data = [];
        for (let c = 0; c < dataRow.length; c++) {
            for (let t = 0; t < parseInt(dataRow[c].Tier); t++) {

                for (let r = 0; r <= parseInt(dataRow[c].Row); r++) {

                    for (let b = 0; b <= parseInt(dataRow[c].Bay); b++) {
                        if (b === 0 && r === 0) {
                            data.push(<TableCell>r\b</TableCell>)
                        } else if (b === 0 && r !== 0) {
                            data.push(<TableCell align='center'>{r}</TableCell>)
                        } else if (b !== 0 && r === 0) {
                            data.push(<TableCell align='center'>{findBay(parseInt(dataRow[c].Bay), b - 1)}</TableCell>)
                        } else {
                            const item = dataC?.filter((x) => {
                                return `${x.ToBay}${x.ToRow}${x.ToTier}${x.ToZone}` == `${findBay(parseInt(dataRow[c].Bay), b - 1)}${r}${t + 1}${dataRow[c].ZoneName}`
                            })

                            data.push(<>
                                <Tooltip arrow title={item?.length === 0 ? '' : `Container No. ${item?.map(x => (x?.ContainerNo))}`} placement="top">
                                    <TableCell sx={{
                                        background: item?.length === 0 ? '#00cf00' : item?.length === 1 ? '#0014ff' : '#ff0000', cursor: 'pointer', position: 'relative',
                                        ':hover': {
                                            WebKitFilter: 'grayscale(100%)',
                                            filter: 'brightness(.5)'
                                        }
                                    }}><Typography sx={{ opacity: '0' }}>999</Typography></TableCell>
                                </Tooltip></>);

                        }

                    }

                    rows.push(<><TableRow>{data}</TableRow></>);
                    data = []
                }
                tbl.push(
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <TableContainer sx={{ padding: '20px', width: 'fit-content' }}>{rows}</TableContainer>
                        <Typography>Tier / Floor: {t + 1}</Typography>
                    </Box>);
                rows = []
            }
            box.push(
                <Box>
                    <Typography variant='h4'>Zone: {dataRow[c].ZoneName}</Typography>
                    {tbl}
                    <Divider sx={{ margin: '40px 0px' }} />
                </Box>
            )
            tbl = []
        }
        setTable(box)
    }

    return (
        <>
            <form onSubmit={e => handleSave(e)}
            >
                <Box
                    sx={{
                        width: "100%",
                        marginTop: "10px",
                        paddingBottom: "24px",
                    }}
                >
                    <Button
                        type="button"
                        variant="outlined"
                        style={{
                            color: "#80c340",
                            borderColor: "#80c340",
                            marginRight: "10px",
                        }}
                        onClick={addRow}
                    >
                        Add Zone
                    </Button>
                    {/* <Button
                    onClick={() => gentable(rows)}
                    variant='contained'
                    // disabled={bay && row && tier ? false : true}
                    style={{
                        // color: bay && row && tier ? "#fff" : "#adb5bd",
                        // background: bay && row && tier ? "#80c340" : "#e9ecef",
                        // borderColor: bay && row && tier ? "#80c340" : "#e9ecef",
                        marginRight: "10px",
                    }}
                >
                    confirms
                </Button> */}
                    {rows.length === 0 ?
                        null
                        : <Button
                            type='submit'
                            variant="contained"
                            style={{
                                color: "#fff",
                                background: "#80c340",
                                marginRight: "10px",
                            }}
                        >
                            save
                        </Button>}
                </Box>
                {rows?.map((x, i) => <>
                    <Grid container key={i}>
                        <Grid xs={12} sx={{ marginBottom: "10px" }}>
                            <TextField required value={x.ZoneName}
                                onChange={(e) => {
                                    const set_rows = rows?.map((v) => {
                                        v.ZoneName =
                                            v?.id === x?.id ? e.target.value : v?.ZoneName;

                                        return v;
                                    });

                                    setRows([...set_rows]);
                                }}
                                InputLabelProps={{ shrink: true }}
                                fullWidth label="Zone Name" variant="outlined" size='small' />
                        </Grid>
                        <Grid xs={3} sx={{ marginRight: "15px" }}>
                            <TextField required value={x.Bay}
                                onKeyPress={(event) => {
                                    if (!/[0-9]/.test(event.key)) {
                                        event.preventDefault();
                                    }
                                }} onChange={(e) => {
                                    const set_rows = rows?.map((v) => {
                                        v.Bay =
                                            v?.id === x?.id ? e.target.value : v?.Bay;

                                        return v;
                                    });

                                    setRows([...set_rows]);
                                }}
                                InputLabelProps={{ shrink: true }}
                                fullWidth label="Bay" variant="outlined" size='small' />
                        </Grid>
                        <Grid xs={3} sx={{ marginRight: "15px" }}>
                            <TextField required value={x.Row}
                                onKeyPress={(event) => {
                                    if (!/[0-9]/.test(event.key)) {
                                        event.preventDefault();
                                    }
                                }} onChange={(e) => {
                                    const set_rows = rows?.map((v) => {
                                        v.Row =
                                            v?.id === x?.id ? e.target.value : v?.Row;

                                        return v;
                                    });

                                    setRows([...set_rows]);
                                }}
                                InputLabelProps={{ shrink: true }}
                                fullWidth label="Row" variant="outlined" size='small' />
                        </Grid>
                        <Grid xs={3} sx={{ marginRight: "15px" }}>
                            <TextField required value={x.Tier}
                                onKeyPress={(event) => {
                                    if (!/[0-9]/.test(event.key)) {
                                        event.preventDefault();
                                    }
                                }} onChange={(e) => {
                                    const set_rows = rows?.map((v) => {
                                        v.Tier =
                                            v?.id === x?.id ? e.target.value : v?.Tier;

                                        return v;
                                    });

                                    setRows([...set_rows]);
                                }}
                                InputLabelProps={{ shrink: true }}
                                fullWidth label="Tier" variant="outlined" size='small' />
                        </Grid>
                        <Grid xs={2} sx={{ marginRight: "15px" }}>
                            <Button
                                onClick={() => deletehand(x?.id)}
                                variant='contained'
                            // disabled={bay && row && tier ? false : true}
                            // style={{
                            //     color: bay && row && tier ? "#fff" : "#adb5bd",
                            //     background: bay && row && tier ? "#80c340" : "#e9ecef",
                            //     borderColor: bay && row && tier ? "#80c340" : "#e9ecef",
                            //     marginRight: "10px",
                            // }}
                            >
                                delete
                            </Button>
                        </Grid>
                    </Grid>
                    <Divider sx={{ margin: '20px 0px' }} />
                </>
                )}
                {table}
            </form>
        </>
    )
}
